export enum MediaLibraryFileType {
  Video = 'video',
  Image = 'image',
  PDF = 'pdf',
}
